var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSsSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.46875 0C7.78125 0 8.97656 0.703125 9.63281 1.82812C10.2891 2.97656 10.2891 4.35938 9.63281 5.48438C8.97656 6.60938 7.78125 7.3125 6.46875 7.3125V0ZM1.875 8.34375V8.32031C1.875 7.35938 2.25 6.42188 2.95312 5.76562C3.63281 5.08594 4.57031 4.71094 5.53125 4.71094V12C4.54688 12 3.63281 11.625 2.92969 10.9453C2.25 10.2656 1.875 9.32812 1.875 8.34375ZM9.63281 10.4297C9.63281 10.9922 9.35156 11.5312 8.85938 11.8125C8.36719 12.0938 7.75781 12.0938 7.26562 11.8125C6.77344 11.5312 6.46875 11.0156 6.46875 10.4531C6.46875 9.89062 6.77344 9.35156 7.26562 9.07031C7.75781 8.78906 8.34375 8.78906 8.83594 9.07031C9.32812 9.35156 9.63281 9.86719 9.63281 10.4297Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSsSymbol);
export default __webpack_public_path__ + "static/media/ss-symbol.cd3b9136a2e992e66491fe01afe12547.svg";
export { ForwardRef as ReactComponent };